import createReactComponent from '../createReactComponent';
export default createReactComponent('s-turn-right', 'IconSTurnRight', [
  ['path', { d: 'M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-0' }],
  [
    'path',
    { d: 'M7 5h9.5a3.5 3.5 0 0 1 0 7h-9a3.5 3.5 0 0 0 0 7h13.5', key: 'svg-1' },
  ],
  ['path', { d: 'M18 16l3 3l-3 3', key: 'svg-2' }],
]);
